var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    { staticClass: "tile is-child box detail-page-tile" },
    [
      _c("div", [
        _c("div", { staticClass: "field is-horizontal" }, [
          _vm._m(0),
          _c("div", { staticClass: "field-body" }, [
            _c("div", { staticClass: "field" }, [
              _c(
                "div",
                { staticClass: "control is-expanded" },
                [
                  _c("multiselect", {
                    attrs: {
                      "track-by": "message",
                      label: "message",
                      placeholder: "Select Template",
                      options: _vm.templates,
                      loading: _vm.isTemplateLoading,
                      searchable: true,
                      "allow-empty": true,
                      "options-limit": _vm.templateFilter.pageSize,
                    },
                    on: { select: _vm.selectTemplate },
                    model: {
                      value: _vm.selectedTemplate,
                      callback: function ($$v) {
                        _vm.selectedTemplate = $$v
                      },
                      expression: "selectedTemplate",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _c("hr"),
      _c(
        "quote-email-modal",
        {
          attrs: {
            emailer: _vm.emailer,
            "quote-ids": _vm.quoteIds,
            "enable-attach": _vm.enableAttach,
            "reply-to-message-id": _vm.innerReplyToEmail.replyToMessageId,
            "reply-to-sender-emails": _vm.replyToSenderEmails,
            "reply-to-email-ccs": _vm.replyToEmailCcs,
            "reply-to-email-bccs": _vm.replyToEmailBccs,
            "email-subject": _vm.innerReplyToEmailSubject,
            "email-message": _vm.innerReplyToEmailMessage,
          },
          on: {
            "update:emailer": function ($event) {
              _vm.emailer = $event
            },
            resetEmail: _vm.resetEmail,
            "new-email": _vm.newEmailInput,
            sent: _vm.sent,
            discard: _vm.discardEmail,
          },
        },
        [
          _c("template", { slot: "template-actions" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary tooltip",
                attrs: { "data-tooltip": "Edit message template" },
                on: {
                  click: function ($event) {
                    _vm.isEmailTemplateModalActive = true
                  },
                },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-pencil mdi-20px" }),
                ]),
                _c("span", [_vm._v("Edit Template")]),
              ]
            ),
          ]),
        ],
        2
      ),
      _c(
        "quote-communication-email-modal",
        {
          attrs: {
            active: _vm.isAttachmentModalActive,
            "show-icon": true,
            "attach-disabled": false,
            "cancel-disabled": false,
            emailer: _vm.emailer,
            "selected-attachment-email-id": _vm.selectedAttachmentEmailId,
            "is-incoming": _vm.isIncoming,
          },
          on: {
            "update:active": function ($event) {
              _vm.isAttachmentModalActive = $event
            },
            ok: function ($event) {
              return _vm.closeAttachModal()
            },
            cancel: function ($event) {
              return _vm.closeAttachModal()
            },
            close: function ($event) {
              return _vm.closeAttachModal()
            },
          },
          model: {
            value: _vm.selectedImages,
            callback: function ($$v) {
              _vm.selectedImages = $$v
            },
            expression: "selectedImages",
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Attachment"),
          ]),
        ]
      ),
      _vm.isEmailTemplateModalActive
        ? _c("vue-email-template-modal", {
            attrs: { active: _vm.isEmailTemplateModalActive },
            on: {
              "update:active": function ($event) {
                _vm.isEmailTemplateModalActive = $event
              },
              close: _vm.closeTemplateModal,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Template")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }